export const CommonModuleTranslations: Array<string> = [
    'xsltName',
    'xsltCreateNew',
    'xsltDescription',
    'xsltTypee',
    'xsltDisplay',
    'Admin.Msg.CancelButton',
    'Admin.Msg.RemoveButton',
    'Admin.Msg.Save',
    'Admin.Msg.Add',
    'Admin.SelectList.ExpandAll',
    'Admin.SelectList.ClearAll',
    'Admin.SelectList.AddAll',
    'CategorySelector.CollapseAll',
    'MainMenu.ToggleMenu',
    'xsltFrom',
    'xsltTo',
    'xsltActive',
    'xsltActiveToday',
    'xsltInactive',
    'xsltDate',
    'xsltDateFrom',
    'xsltDateTo',
    'xsltStartDateFrom',
    'xsltStartDateTo',
    'xsltEndDateFrom',
    'xsltEndDateTo',
    'xlstDateModified',
    'ActionsEdit.SystemID',
    'Admin.AddUserTypeDialog.SystemId',
    'ActionsEdit.Image',
    'Admin.MLDictionaries.Type',
    'xsltModifiedDateFrom',
    'xsltModifiedDateTo',
    'xsltCreatedDateFrom',
    'xsltCreatedDateTo',
    'xsltRank',
    'xsltRanking',
    'Admin.add_edit_attribute.Rank',
    'xsltSelectAllValues',
    'xsltStatus',
    'Admin.SuccessfullyDeleted',
    'Admin.SuccessfullyCreated',
    'Admin.Msg.NewTitle',
    'Admin.Msg.AddSelected',
    'Actions.GenericAction.SaveSuccess',
    'Admin.AttributesDataTable.QuickSearch',
    'Admin.attribute_list.Title',
    'Admin.AddCompany.Required',
    'Msg.CannotStartWithWhiteSpace',
    'Msg.CannotContainWhiteSpace',
    'Admin.PSW.AttributeName',
    'Admin.PSW.AttributeType',
    'Msg.SaveFilters',
    'Msg.ClearAll',
    'Msg.Error',
    'Msg.Or',
    'Msg.AdvancedSearch',
    'Msg.ApplyFilter',
    'Msg.QuickFilter',
    'Msg.ShowOnlySelected',
    'Admin.Msg.Apply',
    'Admin.Msg.Save',
    'Admin.Msg.NoFileSelected',
    'Msg.Alert',
    'Msg.SelectFile',
    'Msg.Select',
    'Admin.Msg.Continue',
    'Msg.FileSuccessfullyDeleted',
    'Msg.Upload',
    'Msg.UploadNewFile',
    'Msg.UploadFiles',
    'Admin.DownloadImage',
    'Msg.OrSelectFromExisting',
    'Msg.Test',
    'AddEditPermission.SelectAll',
    'AddEditPermission.SelectAllCustomTables',
    'AddEditPermission.SelectAllPricebooks',
    'Admin.SetupSpa.DeselectAll',
    'Admin.ParentCategoryHasSelectedChildren',
    'xsltSelectAll',
    'Admin.SetupSpa.Search',
    'Admin.SetupSpa.SelectedItems',
    'Admin.SetupSpa.AdvancedFilter',
    'Admin.Datatable.ItemsSelected',
    'Admin.NumOfRows.1',
    'Admin.NumOfRows.5',
    'Admin.NumOfRows.10',
    'Admin.NumOfRows.20',
    'Admin.Msg.SelectButton',
    'AddEditTab.TabSystemIdWarning',
    'admin.controls.AttributeAdmin.ValueAndDisplayValueRequired',
    'xmlCpqLiteMessage',
    'Admin.StandardTable.DeleteConfirmation',
    'Admin.Multilanguage',
    'Admin.add_edit_user.Total',
    'xmlExitSetup',
    'Admin.LogOut',
    'Admin.Msg.Help',
    'Header.Companion.Notifications',
    'Header.Joule.Assistant',
    'Header.BuiltInSupport',
    'Msg.Blocked',
    'Admin.Msg.ConfirmButton',
    'Msg.IsProtected',
    'Msg.IsSensitive',
    'Admin.General',
    'xmlActions',
    'xsltMoveToTop',
    'xsltMoveToBottom',
    'xsltValue',
    'Admin.Pager.Showing',
    'Admin.Pager.Items',
    'Admin.Pager.Page',
    'Admin.NoDataAvailable',
    'Admin.Datatable.NoColumnsSelected',
    'Msg.Add',
    'Msg.Type2',
    'Msg.Size',
    'Admin.SuccessfullyUploaded',
    'Msg.File',
    'Msg.ListView',
    'Msg.GridView',
    'Admin.MLDictionaries.Rank',
    'xmlGeneral',
    'xmlDocumentGenerationTemplates',
    'Msg.Everyone',
    'Msg.Draft',
    'Msg.Ready',
    'Msg.Simple',
    'Msg.Multisection',
    'Msg.Section',
    'Msg.VisibleTo',
    'Admin.TablesOnQuotes.Language',
    'Admin.TableLanguageSelector.Hint',
    'Admin.QuoteLayout.VisibleToAll',
    'xsltDefineCondition',
    'xmlSimpleProducts',
    'xmlCategories',
    'Authentication.FailedMsg',
    'Authentication.FailedMsgForReload',
    // Alert messages
    'Admin.ErrorMessage.PasswordDifferentFromUsername',
    'UserRegistration.PasswordsNotValid',
    // Cpq Scripting TODO remove to separate file
    'Admin.AddEditScript.CheckSyntax',
    'IronPythonContext.Workbench',
    'Admin.ScriptingCodemirror.ScriptingMethodsList',
    'Admin.modifyitemattributes.LabelDefaultErrMsg',
    'Admin.AddEditScript.ForceProxyGeneration',
    'Admin.AddEditScript.LaunchVSCode',
    'Msg.OK',
    'Msg.Copy',
    'Admin.Msg.ResetButton',
    'xsltDelete',
    'xsltCopy',
    'Msg.Edit',
    'Msg.Delete',
    'Msg.View',
    'Msg.Warning',
    'Admin.Users.DeleteMsg',
    'Admin.Users.DeleteWarning',
    'Admin.Users.DeleteSuccess',
    'Msg.Success',
    'Msg.Yes',
    'Msg.No',
    'Msg.Cancel',
    'Msg.SaveAndBack',
    'Msg.False',
    'Msg.True',
    'Msg.Both',
    'Msg.Result',
    'Msg.ReadOnly',
    'Msg.CopiedToClipboard',
    'Admin.Msg.NoResultsSearch',
    'Admin.AddCompany.Required',
    'xsltRequired',
    'QuoteList.QuickFilter',
    'Admin.CpqPermission.AvailablePermissionGroups',
    'Admin.CpqPermission.SelectedPermissionGroups',
    'Util.Fileupload.MsgSelectedFileExtensionIsForbidden',
    'Util.Fileupload.FileUploaded',
    'Util.Fileupload.MsgFilesAlreadyExist',
    'Admin.DataProtection.InfoLabel',
    'Admin.DataProtection.PersonallyIdentifiableInformation',
    'Admin.DataProtection.SensitiveData',
    'Admin.DataProtection.ContainsPersonallyIdentifiableInformation',
    'Admin.ActionTranslation.Column.Label',
    'Admin.cattree.Title',
    'Admin.Sidemenu.SearchMenu',
    'Admin.Sidemenu.NumberOfItems',
    'Admin.CancelWarningTitle',
    'Admin.CancelWarningMsg',
    'xsltAddNew',
    'xsltSystemID',
    'xsltCode',
    'xsltIsDefault',
    'Msg.OnlyOneDefaultRecordIsAllowed',

    // Formula builder
    'FormulaBuilder.Title',
    'syntaxchecker_HTML_Variables',
    'syntaxchecker_HTML_Tags',
    'syntaxchecker_HTML_Actions',
    'syntaxchecker_HTML_Conditions',
    'syntaxchecker_HTML_Sequences',
    'syntaxchecker_HTML_CTX',
    'syntaxchecker_HTML_Table',
    'syntaxchecker_HTML_List',
    'syntaxchecker_HMTL_InsertVariableButtonLabel',
    'syntaxchecker_HMTL_CTXBuilderButtonLabel',
    'syntaxchecker_HMTL_TableBuilderButtonLabel',
    'syntaxchecker_HMTL_ListBuilderButtonLabel',
    'syntaxchecker_HMTL_InsertOperatorButtonLabel',
    'syntaxchecker_HMTL_CheckSyntaxButtonLabel',
    'syntaxchecker_HMTL_InsertActionButtonLabel',
    'syntaxcheckerCart_HMTL_InsertTagButtonLabel',
    'syntaxchecker_HTML_Step1ActionsMessage',
    'syntaxchecker_HTML_Step1ConditionsMessage',
    'syntaxchecker_HTML_Step2ActionsMessage',
    'FormulaBuilder_ActionsAndConditions_Step2Message',
    'FormulaBuilder_Actions_Step1Message',
    'FormulaBuilder_Conditions_Step1Message',
    'CtxSyntaxChecker.Title',
    'CtxSyntaxChecker.YourCtxTag',
    'FormulaBuilder_CTX_SelectObject',
    'Admin.Msg.Save',
    'Admin.Msg.UpdateButton',
    'Admin.Msg.CancelButton',
    'Admin.Msg.SetRank',
    'Admin.ResetRanks.Info',
    'FormulaBuilder.SelectVariable',
    'FormulaBuilder.SelectAttribute',
    'FormulaBuilder.SelectAttributeValue',
    'FormulaBuilder_Tags_Step1Message',
    'FormulaBuilder_Tags_Step2Message',
    'FormulaBuilder.SelectOperator',
    'FormulaBuilder.SelectSequenceOperator',
    'FormulaBuilder.SelectAction',
    'FormulaBuilder.SelectCondition',
    'FormulaBuilder.SelectAttributesOrAttributeValues',
    'FormulaBuilder.ConditionFormula',
    'FormulaBuilder.StartTyping',
    'Admin.Msg.Insert',
    'TableBuilderAspx_MatchLowerStringConstant',
    'TableBuilderAspx_MatchLowerInclusiveStringConstant',
    'TableBuilderAspx_MatchUpperStringConstant',
    'TableBuilderAspx_MatchUpperInclusiveStringConstant',
    'TableBuilderAspx_BeginsWithStringConstant',
    'TableBuilderAspx_EndsWithStringConstant',
    'TableBuilderAspx_MatchesStringConstant',
    'TableBuilderAspx_TextColumnTypeStringConstant',
    'TableBuilderAspx_NumberColumnTypeStringConstant',
    'TableBuilderAspx_DateColumnTypeStringConstant',
    'TableBuilderAspx_NoneStringConstant',
    'TableBuilderAspx_AscendingStringConstant',
    'TableBuilderAspx_DescendingStringConstant',
    'TableBuilderAspx_ExactConstant',
    'TableBuilderAspx_MinStringConstant',
    'TableBuilderAspx_MaxStringConstant',
    'TableBuilderAspx_CountStringConstant',
    'TableBuilderAspx_AverageStringConstant',
    'TableBuilderAspx_SumStringConstant',
    'TableBuilderAspx_PageTitleListTag',
    'TableBuilderAspx_PageTitle',
    'TableBuilderAspx_Step1Label',
    'TableBuilderAspx_Step1Message',
    'TableBuilderAspx_Step1FromTable',
    'TableBuilderAspx_Step1PreviewTableDataButton',
    'TableBuilderAspx_Step1ReturnLabel',
    'TableBuilderAspx_Step1FromColumnLabel',
    'TableBuilderAspx_Step1ColumnTypeLabel',
    'TableBuilderAspx_Step1SortLabel',
    'TableBuilderAspx_Step2Label',
    'TableBuilderAspx_Step2Message',
    'TableBuilderAspx_Step2ConditionsHeaderColumnLabel',
    'TableBuilderAspx_Step2ConditionsHeaderColumnTypeLabel',
    'TableBuilderAspx_Step2ConditionsHeaderOperatorLabel',
    'TableBuilderAspx_Step2ConditionsHeaderValueLabel',
    'TableBuilderAspx_Step2ConditionsAddNewButtonText',
    'TableBuilderAspx_BuildFormulaLinkButtonText',
    'TableBuilderAspx_NoCustomTablesMsg',
    'TableBuilderAspx_Step3Label',
    'FormulaBuilder_Table_Step3Message',
    'TableBuilderAspx_TestFormulaLinkButtonText',
    'TableBuilderAspx_Step3UseTheFormulaButtonText',
    'FormulaBuilder.AlertMsg.Variables',
    'FormulaBuilder.AlertMsg.Attributes',
    'FormulaBuilder.AlertMsg.AttributeValues',
    'FormulaBuilder.AlertMsg.Tags',
    'FormulaBuilder.AlertMsg.TagParameters',
    'FormulaBuilder.AlertMsg.Operators',
    'FormulaBuilder.AlertMsg.SequenceOperators',
    'FormulaBuilder.AlertMsg.Sequences',
    'FormulaBuilder.AlertMsg.Conditions',
    'FormulaBuilder.AlertMsg.Actions',
    'FormulaBuilder.AlertMsg.ActionAttributeValues',
    'FormulaBuilder.AlertMsg.ActionAttributeValueContainInvalidCharacter',
    'FormulaBuilder.AlertMsg.Table',
    'FormulaBuilder.AlertMsg.ReturnType',
    'FormulaBuilder.AlertMsg.Column',
    'FormulaBuilder.AlertMsg.ColumnType',
    'FormulaBuilder.AlertMsg.TableConditionColumn',
    'FormulaBuilder.AlertMsg.TableConditionColumnType',
    'FormulaBuilder.AlertMsg.TableConditionOperator',
    'FormulaBuilder.AlertMsg.PreviewTable',
    'Menu.Setup',
    'Admin.SideMenu.ChangeSet',
    'Admin.SideMenu.AddNewChangeSet',
    'Admin.ChangeSetModal.Name',
    'Admin.ChangeSetModal.Description',
    'ChangeSet.SearchInput.Placeholder',
    'ChangeSet.HelpIcon.Title',
    'Admin.TenantUrl.HelpLinkTitle',
    'Admin.Validation.OnlyPositiveNumber',
    'Admin.Validation.MustNotBeDecimal',
    'Admin.Validation.BlockedUser',
    'Admin.Validation.CannotStartWithZero',
    'Admin.Validation.NotNumber',
    'Admin.Validation.MustBeGreaterOrEqual',
    'Admin.Validation.MustBeGreaterThen',
    'Admin.Validation.MustBeLessOrEqual',
    'Admin.Validation.MustBeLessThen',
    'Admin.Validation.MustBeAlphaNumeric',
    'Admin.Validation.ContainsWhiteSpace',
    'Admin.Validation.PasswordRules',
    'ActionsEdit.NameRequired',
    'xsltSearchByPeriod',
    'ColumnSearch.ToggleTooltip',
    'ColumnSelection.ToggleModal',
    'xsltAfter',
    'xsltBefore',
    'syntaxchecker_HMTL_Visualize',
    'FormulaBuilder_Variables_Step1Message',
    'FormulaBuilder_Variables_Step2Message',
    'FormulaBuilder_Variables_Step3Message',
    'FormulaBuilder_Sequences_Step1Message',
    'FormulaBuilder_Sequences_Step2Message',
    'syntaxchecker_HMTL_InsertSequenceButtonLabel',
    'Admin.Validation.InvalidEmail',
    'Admin.Validation.InvalidURL',
    'FormulaBuilder_TablePreviewDialogHeader',
    'FormulaBuilder_QuickSearch',
    'Admin.FormulaVisualizer.PageTitle',
    'syntaxcheckerCart_HTML_AvailableTags',
    'FormulaBuilder_TableSyntaxBuilderDialogHeader',
    'FormulaBuilder_ListSyntaxBuilderDialogHeader',
    'TableBuilderAspx_NoneStringConstant',
    'syntaxcheckerCart_HTML_AvailableParametersForSelectedTag',
    'syntaxcheckerCart_HTML_FormulaLabel',
    'syntaxcheckerCart_HTML_ConditionExplanationLabel1or0',
    'CtxSyntaxChecker.ShowEditableArgument',
    'CtxSyntaxChecker.ShowDropdownArgument',
    'syntaxcheckerCart_HMTL_InsertTagButtonLabel',
    'FormulaBuilder_Conditions_InsertCondition',
    'Admin.DefaultLanguage',
    'Admin.ActionTranslation.SelectLanguage',

    // Category tree view
    'AddCategory.Title1',
    'Admin.CategoryTreeView.TitleFor',

    // Pricebook
    'Admin.Pricebooks.Pricebook',
    'Admin.Pricebook.AttributeValuePartNumberIsDynamicallyBuilt',
    'Admin.PricebookTableAddEdit.Name',
    'Admin.PricebookTableAddEdit.PartNumber',
    'Admin.AddEditPricebookEntry.PriceCode',
    'add_edit_currency.JSCurrencyColumn',
    'Admin.AddEditPricebookEntry.Price',
    'Admin.AddEditPricebookEntry.Cost',
    'Admin.AddEditPricebookEntry.RecurringPrice',
    'Admin.AddEditPricebookEntry.RecurringCost',
    'Admin.AddEditPricebookEntry.RecurringPricePeriod',
    'Admin.AddEditPricebookEntry.RecurringCostPeriod',
    'Admin.AddEditPricebookEntry.Description',
    'Admin.Attributes.TotalAttributes',

    // Product data table dialog
    'Admin.ProductList.TotalProducts',
    'Admin.PSW.ProductTable.QuickSearch',
    'Admin.PSW.Step1.PartNumber',
    'Admin.AddEditUserType.SelectProduct',
    'Admin.TitleForUpgradeAliasesToNewVersionMsg',

    // Page recommendations data table dialog
    'Admin.AddEditUserType.SelectPage',
    'Admin.RecommendedPages.TotalPages',
    'Admin.UserTypeEdit.PageName',

    'Admin.PSW.AddNewProductType',
    'Admin.CpqPermission.AvailablePermissionGroups',
    'Admin.CpqPermission.SelectedPermissionGroups',
    'Admin.SetupSpa.SelectPermissionsGroups',
    'Admin.Domain',
    'Admin.TenantDomain',

    //Data tables
    'Admin.Datatable.SelectColumns',
    'Admin.SelectColumns.DisplaySettings',
    'Msg.NotUsed',

    //Script versions
    'Admin.Responsive.Version',
    'Admin.Responsive.VersionComparation',
    'Admin.Responsive.ScriptVersionDetails',
    'AddEditSystemEventScript.Script',
    'AddEditSystemEventScript.Description',
    'NetSuite.createdDate',
    'Admin.Deployment.CreatedBy',
    'Admin.Responsive.Compare',
    'Admin.AddEditScript.History',
    'Admin.ProductVersions.VersionNumber',

    //Certificate Management
    'Msg.Download',
    'Msg.Close',

    //Months
    'Msg.Month.January',
    'Msg.Month.February',
    'Msg.Month.March',
    'Msg.Month.April',
    'Msg.Month.May',
    'Msg.Month.June',
    'Msg.Month.July',
    'Msg.Month.August',
    'Msg.Month.September',
    'Msg.Month.October',
    'Msg.Month.November',
    'Msg.Month.December',

    // http status codes
    'Admin.NoPermission',

    'ItemActionsList.Multilanguage',
    'Admin.UserCustomField.Label',
    'UserCustomFields.Translation.DefaultLanguage',
    'Admin.CustomFields.AddNewTranslation',
    'UserCustomFields.Title',
    'UserCustomFields.Translate',
    'Admin.Msg.AreYouSure',
    'Admin.AuditTrail.PerformerIPAddress',
    'xmlIdentifier',
    'xmlSecret',
    'xmlCredential',
    'xmlTrustedApplications',

    // cpq category tree
    'CategoryModifications.ApplyPermissionsFromParentCategory',
    'Admin.UsersImportExport.SelectValue',
    'Admin.AddEditUser.CustomFields',
    'UserCustomFields.QuickSearch',

    //FileService
    'Admin.DownloadFile.FileNotFound',
    'Admin.DownloadFile.Error',

    'Admin.CPSProvider.ClientId',
    'Admin.CPSProvider.ClientSecret',
    'Admin.Federation.SelectIdentityProvider',
    'Admin.SuccessfullySaved',
    'Admin.Msg.AddNew',

    //License Types
    'Admin.Users.LicenseType.Standard',
    'Admin.Users.LicenseType.External'
];
